import { useEffect, useState } from "react";
import { ShieldCheck, AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "@/lib/api";

export const UsaliCheckPanel = ({ projectId, version }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get(`/projects/${projectId}/usali-check`).then((r) => setD(r.data)).catch(() => setD(null)); }, [projectId, version]);
  if (!d) return null;
  const breaks = d.rows.filter((r) => !r.ok);
  return (
    <section className={`rounded-lg border ${d.ok ? "border-emerald-200 bg-emerald-50/40" : "border-red-200 bg-red-50/40"}`} data-testid="usali-check-panel">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-2.5 text-left" data-testid="usali-check-toggle">
        <span className="inline-flex items-center gap-2 text-xs font-semibold text-slate-800">
          {d.ok ? <ShieldCheck size={14} className="text-emerald-700" /> : <AlertTriangle size={14} className="text-red-600" />}
          USALI statistics check · {d.checked} lines validated · <span data-testid="usali-check-breaks">{d.breaks} break{d.breaks === 1 ? "" : "s"}</span>
          <span className="font-normal text-slate-500">· occupancy basis: {d.include_comp ? "paid + comp rooms" : "paid rooms only"}</span>
        </span>
        {open ? <ChevronUp size={14} className="text-slate-500" /> : <ChevronDown size={14} className="text-slate-500" />}
      </button>
      {open && (
        <div className="px-4 pb-4 overflow-auto max-h-[40vh]">
          <p className="text-[11px] text-slate-500 mb-2">Canonical series — rooms available: <b>{d.canonical.rooms_available}</b> · rooms sold: <b>{d.canonical.rooms_sold}</b> · rooms revenue: <b>{d.canonical.rooms_revenue}</b> · total revenue: <b>{d.canonical.total_revenue}</b> · GOP: <b>{d.canonical.gop}</b>. Tolerance 0.5%.{d.missing?.length ? ` Not found in template: ${d.missing.join(", ")}.` : ""}</p>
          <table className="w-full text-[11px]">
            <thead><tr className="text-[10px] uppercase tracking-wider text-slate-500 text-left"><th className="py-1 pr-2">Status</th><th className="py-1 pr-2">Sheet</th><th className="py-1 pr-2">Line</th><th className="py-1 pr-2">Identity</th><th className="py-1 text-right">Max dev</th></tr></thead>
            <tbody>
              {[...breaks, ...d.rows.filter((r) => r.ok)].map((r) => (
                <tr key={`${r.sheet}-${r.line_id}`} className="border-t border-slate-100" data-testid={`usali-row-${r.line_id}`}>
                  <td className={`py-1 pr-2 font-semibold ${r.ok ? "text-emerald-700" : "text-red-600"}`}>{r.ok ? "OK" : "BREAK"}</td>
                  <td className="py-1 pr-2 text-slate-600">{r.sheet}</td><td className="py-1 pr-2 text-slate-800">{r.label}</td><td className="py-1 pr-2 text-slate-500">{r.identity}</td>
                  <td className="py-1 text-right font-mono">{r.max_dev_pct.toFixed(2)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
